export const PAGE = 1

export const LIMIT = 10
